function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M39.888,282.93H28.596v-47.837c-0.053-2.372,0.042-30.61,31.05-45.879 c28.34-13.955,42.638-21.624,42.774-21.704c0.361-0.187,0.597-0.302,0.99-0.407c1.054-0.374,5.784-2.348,5.784-8.251v-30.479 l11.299,13.875v16.604c0,11.239-8.286,17.095-13.146,18.831c-2.586,1.382-16.871,8.947-42.716,21.665 c-24.962,12.295-24.767,34.583-24.744,35.519c0,0.049,0,0.119,0,0.162V282.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M253.783,282.93h-11.284v-47.901c0-0.066,0-0.125,0-0.189c0.016-0.908,0.218-23.196-24.75-35.491 c-25.839-12.718-40.124-20.283-42.709-21.665c-4.865-1.736-13.147-7.592-13.147-18.831V141.58l11.292-13.872v31.144 c0,6.391,5.708,8.22,5.762,8.239c0.351,0.107,0.694,0.248,1.015,0.419c0.143,0.08,14.438,7.749,42.774,21.704 c31.013,15.269,31.102,43.507,31.048,45.879V282.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M139.865,207.459c-17.736,0-27.291-9.639-32.182-17.725c-5.114-8.44-6.159-16.895-6.206-17.249 c-0.363-3.095,1.856-5.902,4.95-6.273c3.089-0.366,5.899,1.84,6.266,4.927c0.13,1.039,3.438,25.021,27.172,25.021 c24.055,0,29.011-24.344,29.214-25.381c0.591-3.058,3.537-5.074,6.591-4.494c3.059,0.581,5.074,3.502,4.509,6.563 c-0.063,0.349-1.665,8.742-7.284,17.11C165.199,201.406,153.783,207.459,139.865,207.459"
}), /*#__PURE__*/React.createElement("rect", {
  x: 71.992,
  y: 250.08,
  fill: "#233F86",
  width: 11.294,
  height: 32.851
}), /*#__PURE__*/React.createElement("rect", {
  x: 198.656,
  y: 250.08,
  fill: "#233F86",
  width: 11.287,
  height: 32.851
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M98.022,98.78h-3.864c-8.538,0-15.479-6.935-15.479-15.471c0-8.524,6.942-15.458,15.479-15.458h3.864 v7.729h-3.864c-4.269,0-7.736,3.474-7.736,7.729c0,4.268,3.467,7.742,7.736,7.742h3.864V98.78z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M184.6,67.844h3.872c8.53,0,15.472,6.941,15.472,15.479c0,8.523-6.941,15.458-15.472,15.458H184.6v-7.729 h3.872c4.269,0,7.729-3.475,7.729-7.729c0-4.269-3.46-7.743-7.729-7.743H184.6V67.844z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M149.372,153.078h-16.938c-5.563,0-10.848-2.398-14.513-6.567l-16.71-19.112 c-4.368-5.002-6.739-11.409-6.681-18.042V56.244c0-2.135,1.732-3.865,3.871-3.865c0.226,0,22.715-0.046,33.582-3.669 l34.807-11.607c1.755-0.574,3.668,0.148,4.588,1.755l15.465,27.072c0.339,0.581,0.516,1.25,0.516,1.92l-0.083,41.706 c0.049,6.628-2.323,13.031-6.691,18.033l-16.717,18.933C160.208,150.679,154.92,153.078,149.372,153.078 M102.261,60.049v49.331 c-0.042,4.776,1.653,9.354,4.77,12.933l16.7,19.1c2.2,2.49,5.369,3.937,8.703,3.937h16.928c3.333,0,6.51-1.446,8.702-3.948 l16.717-18.921c3.105-3.558,4.796-8.132,4.754-12.875v-0.035l0.072-40.7l-13.392-23.426l-31.791,10.597 C125.183,59.125,109.516,59.871,102.261,60.049"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M149.379,154.121h-16.953c-5.851,0-11.424-2.523-15.289-6.922l-16.715-19.112 c-4.529-5.197-6.99-11.855-6.93-18.742V56.244c0-2.704,2.2-4.908,4.903-4.908c0.225,0,22.536-0.042,33.258-3.616l34.802-11.601 c2.229-0.729,4.665,0.207,5.821,2.223l15.472,27.065c0.425,0.736,0.651,1.584,0.651,2.443l-0.089,41.719 c0.054,6.863-2.413,13.514-6.941,18.708l-16.729,18.927C160.789,151.597,155.225,154.121,149.379,154.121 M167.998,37.95 c-0.297,0-0.592,0.049-0.882,0.144l-34.804,11.594c-11.036,3.688-33.679,3.734-33.916,3.734c-1.554,0-2.822,1.268-2.822,2.822 v53.113c-0.06,6.388,2.222,12.548,6.423,17.362l16.705,19.104c3.463,3.948,8.478,6.213,13.73,6.225h16.938 c5.254-0.012,10.257-2.276,13.719-6.213l16.715-18.938c4.196-4.801,6.479-10.949,6.427-17.326l0.082-41.719 c0-0.5-0.129-0.985-0.366-1.405l-15.472-27.072C169.954,38.473,168.995,37.95,167.998,37.95 M149.368,146.391h-16.935 c-3.642-0.004-7.091-1.576-9.485-4.296L106.243,123c-3.284-3.769-5.062-8.606-5.025-13.632V59.042l1.019-0.023 c6.496-0.167,22.606-0.878,31.853-3.959l32.603-10.871l13.955,24.408l-0.072,40.974c0.049,5.019-1.742,9.841-5.014,13.598 l-16.717,18.921C156.451,144.815,153,146.387,149.368,146.391 M103.303,61.069v48.311c-0.035,4.518,1.565,8.867,4.506,12.246 l16.709,19.099c1.998,2.276,4.88,3.582,7.915,3.582h16.935c3.029,0,5.91-1.306,7.912-3.593l16.717-18.92 c2.94-3.368,4.54-7.694,4.494-12.176l0.069-40.475l-12.826-22.441l-30.986,10.325C125.946,59.966,111.673,60.821,103.303,61.069"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M85.509,75.373L79.859,54.75c-2.888-10.475,1.274-21.399,9.927-27.316L83.042,7.199 c-0.396-1.187-0.202-2.478,0.534-3.486c0.734-1.02,1.895-1.614,3.141-1.614h64.506c15.755,0.014,29.734,9.736,35.306,24.329 c9.828,5.061,15.174,16.146,12.963,27.065l-4.559,22.845l-7.587-1.519l4.563-22.857c1.534-7.61-2.234-15.328-9.188-18.783 l-1.104-0.576c-0.887-0.462-1.563-1.249-1.879-2.204c-4.107-12.295-15.571-20.553-28.517-20.565H92.076l6.045,18.11 c0.606,1.837-0.225,3.83-1.943,4.689c-7.328,3.646-11.073,12.028-8.904,19.917l5.609,20.456L85.509,75.373z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#233F86",
  d: "M84.833,75.296L78.869,55.07c-2.905-10.553,0.984-21.702,9.691-28.045L82.054,7.524 c-0.5-1.488-0.244-3.146,0.68-4.429c0.912-1.268,2.406-2.039,3.983-2.039h64.506c15.874,0.023,30.338,9.9,36.134,24.636 c10.019,5.353,15.424,16.805,13.159,28.003l-4.777,21.097l-9.614-1.927l4.766-21.102c1.442-7.15-2.104-14.41-8.63-17.655 l-1.115-0.581c-1.138-0.592-1.99-1.588-2.394-2.81c-3.967-11.854-15.026-19.833-27.528-19.845h-57.7l5.583,16.751 c0.771,2.299-0.285,4.849-2.466,5.941c-6.889,3.425-10.397,11.298-8.358,18.707l5.903,20.031L84.833,75.296z M86.717,3.144 c-0.906,0-1.766,0.439-2.3,1.173c-0.534,0.737-0.676,1.688-0.39,2.55l6.992,20.979l-0.645,0.444 c-8.413,5.75-12.242,16.277-9.513,26.189l6.709,20.971l5.395-1.718l-6.681-20.867c-2.317-8.405,1.653-17.297,9.424-21.162 c1.257-0.627,1.867-2.097,1.423-3.425L90.636,8.792h60.587c13.396,0.012,25.252,8.565,29.509,21.275 c0.226,0.699,0.715,1.272,1.375,1.611l1.096,0.569c7.351,3.658,11.356,11.856,9.726,19.928l-4.361,21.826l5.542,1.107 l4.368-21.826c2.106-10.425-3.01-21.083-12.423-25.92l-0.357-0.19l-0.142-0.374C180.084,12.45,166.6,3.156,151.223,3.144H86.717z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M81.631,9.208l6.723,17.973c-21.33,13.521-7.109,47.279-5.395,45.76 c1.707-1.512,11.002-4.552,11.002-4.552s-0.189-3.983-0.189-11.944c0-5.478,3.579-5.04,10.196-4.601 c3.009,0.202,6.644,0.404,10.859,0.038c13.46-1.134,34.927-8.294,46.13-13.933c9.638-4.835,13.621,5.017,13.621,5.017 l13.812,26.94c1.873-2.079,8.381,0.374,8.381,0.374c14.605-35.08-9.294-44.569-9.294-44.569 C175.714-0.086,151.621,1.235,151.621,1.235L86.373,1.057C78.977,2.206,81.631,9.208,81.631,9.208"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_2_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible"
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 67.024,
  y: -0.086,
  clipPath: "url(#SVGID_2_)",
  fill: "url(#SVGID_3_)",
  width: 144.351,
  height: 74.546
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_4_",
  d: "M133.664,229.628c0,4.155,3.368,7.515,7.529,7.515c4.15,0,7.529-3.359,7.529-7.515 c0-4.162-3.379-7.53-7.529-7.53C137.031,222.098,133.664,225.466,133.664,229.628"
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_5_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_4_",
  overflow: "visible"
}));

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 133.664,
  y: 222.098,
  clipPath: "url(#SVGID_5_)",
  fill: "url(#SVGID_6_)",
  width: 15.059,
  height: 15.045
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_7_",
  d: "M133.664,257.606c0,4.15,3.368,7.529,7.529,7.529c4.15,0,7.529-3.379,7.529-7.529 c0-4.147-3.379-7.526-7.529-7.526C137.031,250.08,133.664,253.458,133.664,257.606"
}));

var _ref10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_8_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_7_",
  overflow: "visible"
}));

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 133.664,
  y: 250.08,
  clipPath: "url(#SVGID_8_)",
  fill: "url(#SVGID_9_)",
  width: 15.059,
  height: 15.056
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "283.46px",
    height: "283.46px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, _ref4, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -130.2813,
    y1: 582.1665,
    x2: -124.2103,
    y2: 582.1665,
    gradientTransform: "matrix(20.5544 0 0 -20.5544 2754.5654 12003.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#17326A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1798,
    style: {
      stopColor: "#0A468C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#0056A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    style: {
      stopColor: "#0989CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    style: {
      stopColor: "#14C2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#1FC3EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#3EC7E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    style: {
      stopColor: "#6FCDD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9CD3C6"
    }
  })), _ref5), /*#__PURE__*/React.createElement("g", null, _ref6, _ref7, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -56.4946,
    y1: 509.5913,
    x2: -50.4209,
    y2: 509.5913,
    gradientTransform: "matrix(2.4792 0 0 -2.4792 273.7243 1492.9824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#17326A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1798,
    style: {
      stopColor: "#0A468C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#0056A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    style: {
      stopColor: "#0989CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    style: {
      stopColor: "#14C2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#1FC3EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#3EC7E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    style: {
      stopColor: "#6FCDD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9CD3C6"
    }
  })), _ref8), /*#__PURE__*/React.createElement("g", null, _ref9, _ref10, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -56.4946,
    y1: 500.1616,
    x2: -50.4209,
    y2: 500.1616,
    gradientTransform: "matrix(2.4792 0 0 -2.4792 273.7243 1497.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#17326A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1798,
    style: {
      stopColor: "#0A468C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    style: {
      stopColor: "#0056A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5052,
    style: {
      stopColor: "#0989CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    style: {
      stopColor: "#14C2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7529,
    style: {
      stopColor: "#1FC3EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#3EC7E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9216,
    style: {
      stopColor: "#6FCDD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9CD3C6"
    }
  })), _ref11)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.1b205256.svg";
export { ForwardRef as ReactComponent };